<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      class="form-input">
      <el-form-item
        :label="$attrs.name"
        :rules="$attrs.props.rules"
        :class="{isRequired: !isRequired}"
        prop="newValue"
        class="item"
      >
        <p class="rate-box">
          <el-rate
            v-bind="$attrs.props"
            v-model="form.newValue"
          />
        </p>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { common } from '../../mixins/common'

export default {
  name: 'ImRate',
  mixins: [common]
}
</script>

<style scoped>
.form-input{
  display: flex;
  flex-direction: row;
}
  .item{
    display: flex;
    flex-direction: row;
    flex: 1;
    margin-bottom: 20px;
  }
.isRequired{
  padding-left: 10px;
}
.rate-box{
  position: relative;
  /*top: -4px;*/
  top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormComponents/components/rate/index.vue